'use strict';
import { module } from '../app';
import { LoadDiagramBackground } from "../services/findingsBg";

module.directive('diagramView', [ '$rootScope', '$parse', 'scarDrawer', 'safeApply', 'eventsMgr', 'modalService',
  function ($rootScope, $parse, scarDrawer, safeApply, eventsMgr, modalService) {
    return {
      scope: {
        problems: '='
      },
      link: function (scope, elm, attrs) {


        scope.self = {};
        scope.self.svgItems = [];
        scope.self.itemsCount = 0;
        scope.self.paper = d3.select('#' + elm[ 0 ].id).append("svg").attr('width', 800).attr('height', 350);
        scope.self.dragArea = {left: 25, right: 775, top: 70, bottom: 280, rightBorder: 800};

        LoadDiagramBackground(scope.self.paper)
          .then(image => {
            scope.self.image = d3.select(image);
            scope.self.image
                 .moveToBack();
          });

        scope.$watchCollection('problems', function () {
          if (scope.problems && scope.problems.length > scope.self.itemsCount) {
            let newItems = scope.problems.slice(scope.self.itemsCount);

            newItems.forEach(function (item) {
              let f = drawElement(item);
              scope.self.svgItems.push(f);
            });

          }

          if (scope.problems) {
            scope.self.itemsCount = scope.problems.length;
          }
        }, true);


        function drawElement(item) {
          let el = scope.self.paper.append('svg:g');
          let height, width;
          switch (item.Type) {
            case 'Mole':

              el.append('circle').attr('r', 10).attr('fill', 'black').attr('stroke-width', 3).attr('class', 'dragHandle figure');
              height = width = 20;
              break;
            case 'Square':
              height = width = 20;
              el.append('rect')
                .attr('x', -width / 2)
                .attr('y', -height / 2)
                .attr('width', width)
                .attr('height', height)
                .attr('stroke-width', 2)
                .attr('stroke', 'black')
                .attr('fill', 'transparent')
                .attr('class', 'dragHandle figure');
              break;
            case 'Lump':
              el.append('circle').attr('r', 10).attr('stroke-width', 2).attr('stroke', 'black').attr('fill', 'transparent').attr('class', 'dragHandle figure');
              height = width = 20;
              break;
            case 'Scar':
              height = item.Settings.height;
              width = item.Settings.width;
              el.append('rect').attr('x', -width / 2).attr('y', -height / 2).attr('width', width).attr('height', height).attr('fill', 'white').attr('opacity', 0).attr('class', 'dragHandle2');

              el.append("path")
                .data([ item.Settings.path ])
                .attr("class", "dragHandle figure")
                .attr("d", getLine())
                .attr('fill', 'none')
                .attr('stroke', 'black')
                .attr('stroke-width', 3);

              break;
            case 'Pain':
              el.append('svg:path').attr('d', 'M0 -10L10 10L-10 10L0 -10Z').attr('fill', 'white').attr('fill-opacity', 0).attr('stroke', 'black').attr('stroke-width', 2).attr('class', 'dragHandle figure');
              height = 20;
              width = 20;
              break;
            case 'Star':
              item.Settings.scale = item.Settings.scale || 2;
              el.append('svg:path')
                .attr('d', 'M0 -11.4L2.9 -2.8L11.9 -2.8L4.7 2.6L7.3 11.2L0 6.1L-7.3 11.2L-4.7 2.6L-11.9 -2.8L-2.9 -2.8Z')
                .attr('fill', 'white').attr('fill-opacity', 0).attr('stroke', 'black').attr('stroke-width', 0.5).attr('class', 'dragHandle figure');
              height = 20;
              width = 20;
              break;
            case 'Mastectomy':
              height = width = 230;
              if (item.Settings.x < scope.self.paper.attr('width') / 2) {
                item.Settings.x = scope.self.paper.attr('width') / 3.63;
              } else {
                item.Settings.x = scope.self.paper.attr('width') / 4 * 3;
              }
              item.Settings.y = scope.self.paper.attr('height') / 2;

              el.append('svg:path')
              .attr('d', 'M-130 90L-130 -70L0 0L110 -70L110 90')
              .attr('fill', 'white')
              .attr('fill-opacity', 0)
              .attr('stroke-opacity', 0.5)
              .attr('stroke', 'darkgray')
              .attr('stroke-width', 40);

              el.append('rect')
              .attr('rx', 6).attr('ry', 6)
              .attr('x', -width / 2 * 1.7).attr('y', -height / 2)
              .attr('width', width * 1.6).attr('height', height * 1.1 - 30)
              .attr('stroke', 'darkgray')
              .attr('fill-opacity', 0)
              .attr('stroke-opacity', 0.2)
              .attr('class', 'dragHandle figure');

              break;
            case 'ReductionScar':
              height = 126;
              width = 101;

              if (item.Settings.x < scope.self.paper.attr('width') / 2) {
                item.Settings.x = 231;
                item.Settings.side = 'LEFT';
              } else {
                item.Settings.x = 466;
                item.Settings.side = 'RIGHT';
              }

              item.Settings.y = 161;

              el.append('svg:path')
                .attr('d', 'M74.9,42.5c0,13.5-10.9,24.4-24.4,24.4S26,56,26,42.5S37,18.1,50.5,18.1S74.9,29,74.9,42.5z\n' +
                  '\t M50.4,66.9v43.3 M46.2,68.4h8.5 M46.2,72.4h8.5 M46.2,76.4h8.5 M46.2,80.4h8.5 M46.2,84.4h8.5 M46.2,88.4h8.5 M46.2,92.4h8.5\n' +
                  '\t M46.2,96.4h8.5 M46.2,100.4h8.5 M46.2,104.4h8.5 M46.2,108.4h8.5 M79.1,42.5h-8.5 M30.3,42.5h-8.5 M50.4,13.8v8.5 M50.4,62.6v8.5\n' +
                  '\t M70.7,22.2l-6,6 M36.2,56.7l-6,6 M30.2,22.2l6,6 M64.7,56.7l6,6 M76.9,31.5l-7.9,3.3 M31.8,50.2L24,53.5 M39.5,16l3.3,7.9\n' +
                  '\t M58.2,61.1l3.3,7.9 M76.9,53.5l-7.9-3.3 M31.8,34.8L24,31.5 M61.4,16l-3.3,7.9 M42.7,61.1L39.5,69 M8.7,98.1\n' +
                  '\tc6.2,3.8,21.4,12,42.4,12c21.2,0,36.5-8.2,42.6-12 M50.4,105.8v8.5 M91.2,94.7l5.2,6.7 M11.4,94.7l-5.2,6.7 M18.4,98.5l-4.3,7.4\n' +
                  '\t M82.8,99.1l4.3,7.4 M74.9,102.1l3.3,7.9 M26.1,101.6l-3.3,7.9 M66.9,104.2l2.2,8.2 M34.1,103.9l-2.2,8.2 M58.6,105.4l1.1,8.4\n' +
                  '\t M42.2,105.3l-1.1,8.4')
                .attr('fill', 'transparent')
                .attr('stroke', 'black')
                .attr('stroke-width', 2)
                .attr('class', 'figure reduction-scar');
              break;
            case 'CircularScar':
              height = 50.93;
              width = 50.93;

              const pathData = `M24.4,0c0,13.5-10.9,24.4-24.4,24.4S-24.5,13.5-24.5,0S-13.5,-24.4,0,-24.4S24.4,-13.5,24.4,0z
                M28.6,0h-8.5 M-20.2,0h-8.5 M-0.1,-28.7v8.5 M-0.1,20.1v8.5
                M20.2,-20.3l-6,6 M-14.3,14.2l-6,6 M-20.3,-20.3l6,6 M14.2,14.2l6,6 M26.4,-11l-7.9,3.3 M-18.7,7.7L-26.5,11 M-11, -26.5l3.3,7.9
                M7.7,18.6l3.3,7.9 M26.4,11l-7.9-3.3 M-18.7,-7.7L-26.5,-11 M10.9,-26.5l-3.3,7.9 M-7.8,18.6L-11,26.5`;

              problemElement.append('svg:path')
                  .attr('d', pathData)
                  .attr('stroke-width', '2.5')
                  .attr('stroke', 'black')
                  .attr('fill', 'transparent')
                  .attr('transform', 'scale(0.8)')
                  .attr('class', 'dragHandle figure');

              appendLegend.lengthOfLegend += 80;
              break;
          }


          el.datum({
            x: Math.max(scope.self.dragArea.left, Math.min(item.Settings.x, scope.self.dragArea.right)),
            y: Math.max(scope.self.dragArea.top, Math.min(item.Settings.y, scope.self.dragArea.bottom)),
            path: item.Settings.path,
            width: width,
            height: height,
            origWidth: width,
            origHeight: height,
            scale: item.Settings.scale || 1,
            item: item
          });

          el.moveToFront();
          el.append("text")
            .attr('class', 'barLabel')
            .attr("dy", ".35em")
            .attr("text-anchor", "middle")
            .text(function (d) {
              return d.item.index;
            });

          redraw(el.select('.figure').node());
          return el;
        }

        function selected() {
          return false;
        }

        function redraw(el) {
          let node = d3.select(el.parentNode);

          node.attr("transform", function (d, i) {
            return "translate(" + [ d.x, d.y ] + ")scale(" + d.scale + ")";
          });
          node.select('.dragHandle')
              .attr('stroke-dasharray', function (d) {
                return selected(d) ? [ 5, 5 ] : '';
              })
              .attr('stroke', function (d) {
                return selected(d) ? 'green' : 'black';
              })
              .attr('stroke-width', function (d) {
                return 1 / d.scale * 4 + .5;
              });

          node.select('.barLabel')
              .attr('font-size', '15px')
              .attr('font-family', 'sans-serif')
              .attr('transform', function (d) {
                return "scale(" + 1 / d.scale + ")";
              })
              .attr("x", function (d) {
                if (d.item.Type === 'Square') {
                  return -(d.origHeight / 2 * d.scale) - 10;
                }
                if (d.item.Type === 'Mastectomy') {
                  return -(d.origHeight / 2 * d.scale) - 25;
                }
                if (d.item.Type === 'ReductionScar') {
                  return -(d.origHeight / 2 * d.scale) + 70;
                }
                return -(d.origHeight / 2 * d.scale) - 5;
              })
              .attr("y", function (d) {
                if (d.item.Type === 'Square') {
                  return -(d.origWidth / 2 * d.scale) - 10;
                }
                if (d.item.Type === 'Mastectomy') {
                  return -(d.origHeight / 2 * d.scale) + 40;
                }
                if (d.item.Type === 'ReductionScar') {
                  return -(d.origHeight / 2 * d.scale) + 80;
                }
                return -(d.origWidth / 2 * d.scale) - 5;
              })
              .text(function (d) {
                return d.item.index;
              });
        }

        function getLine() {
          return d3.svg.line()
                   .interpolate("linear")
                   .x(function (d, i) {
                     return (d || [ 0, 0 ])[ 0 ];
                   })
                   .y(function (d, i) {
                     return (d || [ 0, 0 ])[ 1 ];
                   });
        }
      }
    };
  }
]);



// WEBPACK FOOTER //
// ./src/scripts/directives/diagramView.js